import { render, staticRenderFns } from "./QuestionProgressBarItem.vue?vue&type=template&id=8a2898b4&scoped=true&"
import script from "./QuestionProgressBarItem.vue?vue&type=script&lang=js&"
export * from "./QuestionProgressBarItem.vue?vue&type=script&lang=js&"
import style0 from "./question-progress-bar-item.scss?vue&type=style&index=0&id=8a2898b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2898b4",
  null
  
)

export default component.exports